import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import './SubscriptionConfig.scss';
import NavBox from '../Common/NavBox/NavBox';

const SubscriptionConfigNav = ({ onClick, activeItemName }) => {

    return (
        <Fragment>
            <NavBox title="Location Configuration" menuItems={["Area", "Brand", "Continent", "Management_Company", "Project_Manager", "Region", "Type"]} onSelectedItem={onClick} activeItemName={activeItemName} />
            <NavBox title="Task Configuration" menuItems={["Baseline_Job_Titles", "Community", "Department", "Discipline", "Status", "Phase"]} onSelectedItem={onClick} activeItemName={activeItemName} />
        </Fragment>

    );

}
SubscriptionConfigNav.propTypes = {
    activeItemName: PropTypes.string,
    onClick: PropTypes.func.isRequired
};

export default SubscriptionConfigNav

